











































import { Component, Prop, Vue } from "vue-property-decorator";
import { AZNCONNECT_API } from "../../services/aznconnect-api";
import { ReferralEspoedDetailsModel } from "@/types/aznconnect_api";
import store from "@/store/index";

interface AmbulanceNurseUserData {
  Mail: string;
  DisplayName: string;
}

@Component({})
export default class TeamsCallAmbulance extends Vue {
  @Prop({ default: null })
  referral!: ReferralEspoedDetailsModel;

  enableTeamsCallAmbulance: boolean = false;
  ambulanceNurseUserData: AmbulanceNurseUserData | null = null;
  isLoading: boolean = false;

  async mounted() {
    this.enableTeamsCallAmbulance =
      store.getters.applicationConfiguration.enableTeamsCallAmbulance;

    if (this.enableTeamsCallAmbulance) {
      try {
        this.isLoading = true;
        const response = await AZNCONNECT_API.get<AmbulanceNurseUserData>(
          `/Graph/GetRavUserByEmployeeNumber/?employeeNumber=${
            this.referral.AmbulanceNurseIdentificationNumber
          }`,
          // fixme todo possible fallback to referral.AmbulanceDriverIdentificationNumber
        );
        this.ambulanceNurseUserData = response.data;
      } catch {
        this.ambulanceNurseUserData = null;
      } finally {
        this.isLoading = false;
      }
    }
  }
}
